// extracted by mini-css-extract-plugin
export default {"uploader":"MainPage_uploader__+REGO"};